import React, { useState } from "react";
import {
  handleStructure,
  multipleSelection,
  singleSelection,
} from "../DSFunction";
import { updateGridInfo } from "../../../../Features/gridViewInfo";
import { updateRoofDetails } from "../../../../Features/quantityInfo";
import { useDispatch, useSelector } from "react-redux";
import { roofStructureData } from "../structureFunction";
import Modal from "react-bootstrap/Modal";
import StructurePreview from "../structruePreview";
import { panelInformation } from "../../../DataFiles/panelInformation";

export default function StructureOption() {
  const dispatch = useDispatch();
  const roofInfo = useSelector((state) => state.roof);
  const gridInfo = useSelector((state) => state.grid);
  const quantityInfo = useSelector((state) => state.quantity);
  const designParameter = useSelector((state) => state.designParameter);
  const roofData = quantityInfo.roofData;
  const roofIndex = quantityInfo.roofNo;
  const roofDetail = roofData.length > 0 ? roofData[roofIndex] : [];
  const [tooltip, setTooltip] = useState();

  const [previewStructure, setPreviewStructure] = useState(false);

  let panel = [];

  if (roofDetail?.moduleType !== "Select") {
    const panelInfo = panelInformation.find(
      (item) => item.brand === roofDetail?.module
    );
    panel = panelInfo.panelType.find(
      (item) => item.name === roofDetail?.moduleType
    );
  }

  const handleClose = () => {
    setPreviewStructure(false);
  };

  return (
    <>
      {roofDetail.roofType !== "Select" && (
        <>
          <div className="selectionButton">
            <div className="structureBtn">
              {tooltip === "Single" && (
                <h4 className="warning">
                  <div className="sideArrow"></div>
                  Place only single structure type on one roof.
                </h4>
              )}
              <button
                onClick={() => singleSelection(dispatch, roofIndex)}
                onMouseEnter={() => setTooltip("Single")}
                onMouseLeave={() => setTooltip()}
                style={{
                  backgroundColor:
                    roofDetail.structureType === "Single"
                      ? "#ff7f1e"
                      : "#072a4066",
                }}
              >
                Single Structure
              </button>
            </div>
            <div className="structureBtn">
              {tooltip === "Multiple" && (
                <h4 className="warning">
                  <div className="sideArrow"></div>
                  Place multiple structures on one roof. This option is only
                  available for Flat Roof Type Structures.
                </h4>
              )}
              <button
                onClick={() => {
                  roofDetail.roofType === "Flat Roof"
                    ? multipleSelection(dispatch, roofIndex)
                    : alert(
                        "This option is only available for Flat Roof Type Structures."
                      );
                }}
                onMouseEnter={() => setTooltip("Multiple")}
                onMouseLeave={() => setTooltip()}
                style={{
                  backgroundColor:
                    roofDetail.structureType === "Multiple"
                      ? "#ff7f1e"
                      : "#072a4066",
                }}
              >
                Multiple Structure
              </button>
            </div>
          </div>
          <div className="title">
            <h1>Select Structure</h1>
            {roofDetail.mountingStructure !== "Select" && (
              <h6
                onClick={() => setPreviewStructure(true)}
                onMouseEnter={() => setTooltip("previewStructure")}
                onMouseLeave={() => setTooltip()}
              >
                {tooltip === "previewStructure" && (
                  <span className="warning">
                    <div className="sideArrow"></div>
                    Preview Structure Datasheet
                  </span>
                )}
                <i className="bi bi-eye-fill"></i>
                <span>Preview</span>
              </h6>
            )}
          </div>
        </>
      )}
      <div className="roofContainer">
        {roofStructureData.map((structureItem, index) => (
          <React.Fragment key={index}>
            {structureItem.roofType === roofDetail.roofType && (
              <div
                className={
                  roofDetail.mountingStructure === structureItem.name
                    ? "roofBox roofActive"
                    : "roofBox roofBoxD"
                }
                onClick={() => {
                  if (structureItem.maxLimit < panel.width) {
                    alert(
                      `${structureItem.name} is not available for large panel`
                    );
                  } else if (roofDetail.structureType === "Multiple") {
                    dispatch(
                      updateRoofDetails({
                        index: quantityInfo.roofNo,
                        fields: {
                          mountingStructure: structureItem.name,
                        },
                      })
                    );
                  } else {
                    dispatch(updateGridInfo({ addStructure: false }));
                    handleStructure({
                      structureItem,
                      dispatch,
                      roofInfo,
                      gridInfo,
                      quantityInfo,
                      roofDetail,
                      designParameter,
                    });
                  }
                }}
              >
                <img
                  src={structureItem.structureImage}
                  alt={`${structureItem.name}`}
                />
                <h2>{structureItem.name}</h2>
                {roofDetail.moduleType !== "Select" &&
                  structureItem.maxLimit < panel.width && (
                    <div className="disable"></div>
                  )}
              </div>
            )}
          </React.Fragment>
        ))}
      </div>

      {/* Structure DataSheet Modal  */}
      <Modal
        show={previewStructure}
        onHide={handleClose}
        keyboard={false}
        centered
        className="datasheetModal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Structure Datasheet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <StructurePreview roofDetail={roofDetail}></StructurePreview>
        </Modal.Body>
      </Modal>
    </>
  );
}
